import React, { useRef, useState } from "react";
import { Row, Col, Button, Input, Modal, Alert } from "antd";
import { Typography } from "antd";
import { validOtp } from "../../../../../services";
import { upsertWalletTransactionService } from "../../../../../services";
import useAuthStore from "../../../../../stores/useAuthStore";
import { message } from "antd";

const { Title } = Typography;

const WalletOtpModal = ({
  showWalletOtpModal,
  setShowWalletOtpModal,
  walletOtpAmount,
  selectedCustomer,
  setSelectedCustomer,
  selectedPaymentMethod,
  requestPayment,
  setIswalletFlag,
  setRedeemAmount,
  cart,
}) => {
  const [walletOtp, setWalletOtp] = useState(Array(6).fill(""));
  const [walletOtpError, setWalletOtpError] = useState(false);
  const walletOtpInputsRef = useRef([]);
  const tillData = useAuthStore((s) => s.tillData);

  const handleWalletOtpVerify = async () => {
    const otpValue = walletOtp.join("");

    try {
      const validOtpResponse = await validOtp(cart.customer.cwrCustomerId, otpValue, walletOtpAmount, "wallet");
      const status = validOtpResponse?.data?.data?.validOtp?.status;

      if (status === "200") {
        const amountValue = walletOtpAmount;
        const walletBalance = parseFloat(selectedCustomer[0]?.currentBalance || 0);

        const storedTillData = useAuthStore.getState().tillData || {};
        const bunitId = storedTillData?.tillAccess?.csBunit?.csBunitId;

        const payload = {
          bunitId,
          customerId: cart.customer.cwrCustomerId,
          trxType: "WD",
          trxValue: amountValue,
          tillId: storedTillData?.tillAccess.cwrTill.cwrTillID,
        };

        const response = await upsertWalletTransactionService(payload);

        if (response?.status !== "200") {
          message.error("Wallet deduction failed");
          return;
        }

        const updatedCustomer = {
          ...selectedCustomer[0],
          currentBalance: walletBalance - amountValue,
        };

        setSelectedCustomer([updatedCustomer]);
        requestPayment({ ...selectedPaymentMethod, walletAlreadyDeducted: true }, amountValue.toFixed(2));

        setRedeemAmount("");
        setIswalletFlag(false);
        setShowWalletOtpModal(false);
        setWalletOtp(Array(6).fill(""));
      } else {
        setWalletOtpError(true);
      }
    } catch (err) {
      message.error("Invalid OTP");
    }
  };

  const handleCancel = () => {
    setShowWalletOtpModal(false);
    setWalletOtp(Array(6).fill(""));
    setWalletOtpError(false);
  };

  return (
    <Modal
      open={showWalletOtpModal}
      footer={null}
      closable={false}
      centered
      styles={{ body: { textAlign: "center", padding: "40px 24px" } }}
    >
      <Title level={4}>Verify OTP for Wallet Redemption</Title>
      <p style={{ marginBottom: 20 }}>Redeeming wallet amount: {walletOtpAmount}</p>

      <Row justify="center" gutter={8} style={{ marginBottom: 28 }}>
        {walletOtp.map((digit, idx) => (
          <Col key={idx}>
            <Input
              maxLength={1}
              value={digit}
              ref={(el) => (walletOtpInputsRef.current[idx] = el)}
              onChange={(e) => {
                const newOtp = [...walletOtp];
                newOtp[idx] = e.target.value;
                setWalletOtp(newOtp);
                if (e.target.value && idx < 5) {
                  walletOtpInputsRef.current[idx + 1]?.focus();
                }
              }}
              style={{ width: 50, height: 50, textAlign: "center", fontSize: 20 }}
            />
          </Col>
        ))}
      </Row>

      {walletOtpError && (
        <Alert type="error" message="Invalid OTP" showIcon style={{ marginBottom: 20 }} />
      )}

      <Row justify="center" gutter={16}>
        <Col>
          <Button onClick={handleCancel}>Cancel</Button>
        </Col>
        <Col>
          <Button
            style={{ color: "white", background: "#253856", borderColor: "#253856" }}
            type="primary"
            onClick={handleWalletOtpVerify}
            disabled={walletOtp.includes("")}
          >
            Verify OTP
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default WalletOtpModal;
